import { ServerApi } from "src/config";

const GetUrlApi = () => {
  return process.env.NODE_ENV === "production"
    ? `${ServerApi.prodUrl}`
    : `${ServerApi.localUrl}`;
};

export default GetUrlApi;
